export default "__VITE_ASSET__BUhKe6Sz__"